import { IAuditOnsiteFieldInfo } from "../../../../../interfaces";


export const getCountValueHandler = (fields: IAuditOnsiteFieldInfo[]): number =>
  fields.reduce((acc: number, el: IAuditOnsiteFieldInfo) => acc + el.points, 0)